// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2-ESs","errorLogs":"styles_errorLogs__21yVJ"};